import ViewFactory from "../helpers/viewfactory";
import { isPlainObject } from "../../../utils";

export default function view() {
  const $this = isPlainObject(this) ? this : Object.create(null);

  return ViewFactory({
    NAME: 'PLACEHOLDER_VIEW'
  }).call($this);
}
